module.exports = __webpack_public_path__ + "static/10_annahita_sarty-fdf3e4c162669e3c97de23fdd568b002.jpg";